import React from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  Divider,
  Space,
} from "antd";
import {
  HomeOutlined,
  ArrowRightOutlined,
  CheckOutlined,
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const Services = ({ content }) => {
  if (!content) {
    return null;
  }

  const metadata = content.metadata || {};
  const services = metadata.items || [];
  const processSteps = metadata.process || [];
  const cta = metadata.cta;
  const sectionTitle = content.title || "";
  const sectionSubtitle = content.subtitle || "";

  return (
    <div className="content-section services-section" style={{ padding: "80px 50px", background: "#f5f5f5" }}>
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: 60 }}>
        {sectionTitle && <Title level={2}>{sectionTitle}</Title>}
        {sectionSubtitle && (
          <Paragraph style={{ maxWidth: 700, margin: "0 auto" }}>
            {sectionSubtitle}
          </Paragraph>
        )}
      </div>

      {content.image_url && (
        <div style={{ maxWidth: 1100, margin: "0 auto 48px" }}>
          <img
            src={content.image_url}
            alt={sectionTitle || "Services"}
            loading="lazy"
            style={{
              display: "block",
              width: "100%",
              maxHeight: 440,
              objectFit: "cover",
              borderRadius: 16,
            }}
          />
        </div>
      )}

      {/* Services Grid */}
      <Row gutter={[32, 32]}>
        {services.map((service, index) => (
          <Col xs={24} md={12} lg={8} key={index}>
            <Card hoverable style={{ height: "100%" }}>
              <div style={{ marginBottom: 20 }}>
                <HomeOutlined style={{ fontSize: 32, color: "#916847" }} />
              </div>

              <Title level={4}>{service.title}</Title>
              <Paragraph>{service.description}</Paragraph>

              <Space orientation="vertical">
                {(service.features || []).map((feature) => (
                  <Space key={feature} align="start">
                    <CheckOutlined style={{ color: "#916847" }} />
                    <Text>{feature}</Text>
                  </Space>
                ))}
              </Space>
            </Card>
          </Col>
        ))}
      </Row>

      {!!processSteps.length && (
        <>
          <Divider style={{ margin: "80px 0" }} />
          <div style={{ textAlign: "center", marginBottom: 60 }}>
            {metadata.process_title && <Title level={3}>{metadata.process_title}</Title>}
            {metadata.process_subtitle && (
              <Paragraph style={{ maxWidth: 800, margin: "0 auto" }}>
                {metadata.process_subtitle}
              </Paragraph>
            )}
          </div>

          <Row gutter={[32, 32]}>
            {processSteps.map((item) => (
              <Col xs={24} md={12} lg={6} key={item.step || item.title}>
                <Card style={{ textAlign: "center" }}>
                  <div
                    style={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      background: "#916847",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 20,
                      fontWeight: "bold",
                      margin: "0 auto 20px",
                    }}
                  >
                    {item.step}
                  </div>

                  <Title level={5}>{item.title}</Title>
                  {item.duration && <Text type="secondary">{item.duration}</Text>}
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}

      {cta && (
        <>
          <Divider style={{ margin: "80px 0" }} />
          <Card
            style={{
              textAlign: "center",
              background: "#fff7e6",
              borderRadius: 16,
            }}
          >
            {cta.title && <Title level={4}>{cta.title}</Title>}
            {cta.subtitle && (
              <Paragraph style={{ maxWidth: 600, margin: "0 auto 20px" }}>
                {cta.subtitle}
              </Paragraph>
            )}
            {cta.button_label && (
              <Button
                type="primary"
                size="large"
                icon={<ArrowRightOutlined />}
                href={cta.href || "#contact"}
              >
                {cta.button_label}
              </Button>
            )}
          </Card>
        </>
      )}
    </div>
  );
};

export default Services;
